import { FormControl } from '@mui/material';
import styled from '@emotion/styled';

export const StyledFormControl = styled(FormControl)({
  '.MuiInputLabel-root': {
    fontSize: '14px !important',
    marginTop: '-2px',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'rgba(0, 0, 0, 0.6)',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#b0e9b3',
  },
});
